// extracted by mini-css-extract-plugin
export default {"root":"PlasmicCardPaymentButton_root__2P5n+","text":"PlasmicCardPaymentButton_text__p+eFE"};